if(typeof OIMO === 'undefined') {var e = new Error("Cannot find module 'OIMO'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = OIMO;